module.exports = __webpack_public_path__ + "media/images/oir-logo-da58c226cb80f7f288535dee20844361.svg";